export default __webpack_public_path__ + "static/media/TERMINAL_ICON_06.4f7de464.svg";